import { render } from "./LeaderBoard.vue?vue&type=template&id=6b595529&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"

import "./LeaderBoard.vue?vue&type=style&index=0&id=6b595529&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b595529"]])

export default __exports__